module.exports = __webpack_public_path__ + "img/Jb.530a5a8b.png";